/* import __COLOCATED_TEMPLATE__ from './class-group-penalties-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class ClassGroupPenaltiesCardComponent extends Component 
{
	@service store;
	
	@tracked classGroup = null;
	
	@tracked selectedPts = null;
	@tracked selectedPtsName = null;
	@tracked selectedClassGroupPts = null;
	@tracked selectedClassGroupPtsName = null;
	
	@tracked selectedRacePts = null;
	@tracked selectedRacePtsName = null;
	
	@tracked penalty;
	
	@action
	async selectClassGroup(event)
	{
		var classGroupId = event.target.value;
		
		if(classGroupId == '-')
		{
			this.classGroup = null;
		}
		else
		{
			this.classGroup = await this.store.findRecord('classGroup', classGroupId);
		}
	}
	
	@action
	selectPts(event)
	{
		var ptsCol = event.target.value;
		
		if(ptsCol == '-')
		{
			this.selectedPts = null;
			this.selectedPtsName = null;
		}
		else
		{
			this.selectedPts = ptsCol;
			this.selectedPtsName = ptsCol+"Name";
		}
	}
	
	@action
	selectClassGroupPts(event)
	{
		var ptsCol = event.target.value;
		
		if(ptsCol == '-')
		{
			this.selectedClassGroupPts = null;
			this.selectedClassGroupPtsName = null;
		}
		else
		{
			this.selectedClassGroupPts = ptsCol;
			this.selectedClassGroupPtsName = ptsCol+"Name";
		}
	}
	
	@action
	selectRacePts(event)
	{
		var ptsCol = event.target.value;
		
		if(ptsCol == '-')
		{
			this.selectedRacePts = null;
			this.selectedRacePtsName = null;
		}
		else
		{
			this.selectedRacePts = ptsCol;
			this.selectedRacePtsName = ptsCol+"Name";
		}
	}

	@action
	overrideChanged(result,browserEvent)
	{
		result.set('ptsOverride',browserEvent.target.value);
		this.updatePenalty();
	}
	
	@action
	penaltySelectionChanged(result,browserEvent)
	{
		result.set('useResultForPenalty', browserEvent.target.checked);
		this.updatePenalty();
	}
	
	@action
	async savePenalty()
	{
		this.classGroup.set(this.selectedClassGroupPts, this.penalty);
		await this.classGroup.save();
		await this.args.event.hasMany('entries').reload();

		var results = await this.classGroup.get('results');
		for(var result of [...results])
		{
			var value = result.get(this.selectedPts);
			if(result.ptsOverride)
				value = parseFloat(result.ptsOverride);
			
			var entry = await this.store.findRecord('Entry',result.id);
			entry.set(this.selectedRacePts,value);
			await entry.save();
		}
	}
	
	async updatePenalty()
	{
		var pts = [];
		var results = await this.classGroup.get('results');
		for(var result of [...results])
		{
			if(result.useResultForPenalty)
			{
				var value = result.get(this.selectedPts);
				if(result.ptsOverride)
					value = parseFloat(result.ptsOverride);
				pts.push({value:value,used:true});
			}
		}
		if(pts.length != 3)
		{
			this.penalty = null;
			return;
		}
		
		var sum = 0;
		pts.forEach(function(value)
		{
				sum += value.value;
		});
		this.penalty = (sum/3.5).toFixed(2);
	}
}